import React, { Component, Fragment } from "react";
import CenterElement from "../../activity/activityComponent/CenterElement";
import DragItem from "../model/DragItem";
import DragItemUI from "./DragItemUI";

class DragContainerUI extends Component {
  render = () => {
    let { activity, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;

    let { dragItemList } = activity.dragContainerModel;
    let { selectedStyle } = activity.dragContainerModel;

    return (
      <Fragment>
        <div style={{ textAlign: "center",display : window.innerWidth <400 ? "flex":"", justifyContent:"center" }}>{this.getDragItems()}</div>
      </Fragment>
    );
  };

  getDragItems = () => {
    let { activity, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;

    let { dragItemList } = activity.dragContainerModel;

    return (
      <Fragment>
        <div className="d-flex  flex-wrap  questions-container">
          {dragItemList.map((dragItem, index) => {
            return (
              <div
                className="p-2 drag-container"
                key={index}
                style={{
                  display: window.innerWidth > 400 ? "" : "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <DragItemUI
                  quizViewer={quizViewer}
                  dragItem={dragItem}
                  activity={activity}
                />
              </div>
            );
          })}
        </div>
      </Fragment>
    );
  };

  handleTxtChange = (e, dragItem) => {
    dragItem.dragTxt = e.target.innerHTML;
    console.log(dragItem);
    console.log(dragItem.getAsJson());
  };

  handleAddDragItem = () => {
    let { activity, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;

    let { dragItemList } = activity.dragContainerModel;

    let dragItem = new DragItem();
    dragItem.dragTxt = "";
    activity.dragContainerModel.addDragItem(dragItem);

    quizViewer.setState({ quizViwerModel });
  };
}

export default DragContainerUI;
